export default __webpack_public_path__ + "static/media/Check.cf3d7fbd.svg";